/**
 * Helpers for chair mat measurement validation with Keystone Product Options.
 * Keystone renders visible inputs via React (name = internal form key) and only
 * syncs empty/hidden properties[Option Label] inputs on submit. These helpers
 * locate fields by the option label text (e.g. "Side A") inside #key_options_block.
 */
(function (window, $) {
    "use strict";

    if (!$ || window.ChairMatValidation) {
        return;
    }

    function getOptionTitleText($title) {
        var directText = $title
            .contents()
            .filter(function () {
                return this.nodeType === 3;
            })
            .text()
            .replace(/\s+/g, " ")
            .trim();

        if (directText) {
            return directText;
        }

        return $title
            .clone()
            .children()
            .remove()
            .end()
            .text()
            .replace(/\s+/g, " ")
            .trim()
            .replace(/\*$/, "")
            .trim();
    }

    function findSideInput(sideLabel) {
        var $block = $("#key_options_block");

        if ($block.length) {
            var $title = $block.find(".key_option_title").filter(function () {
                return getOptionTitleText($(this)) === sideLabel;
            }).first();

            if ($title.length) {
                var forId = $title.attr("for");
                if (forId) {
                    var $byId = $("#" + forId);
                    if ($byId.length) {
                        return $byId;
                    }
                }

                var $wrapperInput = $title
                    .closest(".key_option_wrapper")
                    .find('input[type="text"], input[type="number"], textarea')
                    .filter(":visible")
                    .first();

                if ($wrapperInput.length) {
                    return $wrapperInput;
                }
            }
        }

        // Bold / legacy fallback: prefer real editable inputs over Keystone hidden stubs
        var $named = $("[name='properties[" + sideLabel + "]']");
        var $editable = $named.filter(function () {
            var type = ($(this).attr("type") || "").toLowerCase();
            return type !== "hidden";
        });

        if ($editable.length) {
            return $editable.first();
        }

        return $();
    }

    function allSidesFound(sideLabels) {
        for (var i = 0; i < sideLabels.length; i++) {
            if (!findSideInput(sideLabels[i]).length) {
                return false;
            }
        }
        return true;
    }

    /**
     * Wait until Keystone (or legacy Bold) has rendered the required Side fields.
     */
    function waitForSides(sideLabels, callback, options) {
        options = options || {};
        var timeoutMs = options.timeoutMs || 20000;
        var intervalMs = options.intervalMs || 250;
        var started = Date.now();
        var settled = false;
        var observer = null;

        function finish() {
            if (settled) {
                return;
            }
            settled = true;
            if (observer) {
                observer.disconnect();
            }
            callback();
        }

        function attempt() {
            if (settled) {
                return;
            }

            if (allSidesFound(sideLabels)) {
                finish();
                return;
            }

            if (Date.now() - started >= timeoutMs) {
                console.warn(
                    "[ChairMatValidation] Timed out waiting for side fields:",
                    sideLabels.join(", ")
                );
                if (observer) {
                    observer.disconnect();
                }
                return;
            }

            window.setTimeout(attempt, intervalMs);
        }

        // Keystone mounts after LCP / load; also observe DOM inserts
        var $block = $("#key_options_block");
        if ($block.length && typeof MutationObserver !== "undefined") {
            observer = new MutationObserver(function () {
                if (allSidesFound(sideLabels)) {
                    finish();
                }
            });
            observer.observe($block.get(0), { childList: true, subtree: true });
        }

        attempt();
    }

    function bindSideField(sideLabel, chairmat, sideIndex, onChange) {
        var $input = findSideInput(sideLabel);
        if (!$input.length) {
            return $input;
        }

        var readValue = function () {
            var value = $input.val();
            chairmat.sides[sideIndex] = value === undefined ? null : value;
        };

        readValue();
        $input.on("input change blur", function () {
            readValue();
            onChange(chairmat);
        });

        return $input;
    }

    window.ChairMatValidation = {
        findSideInput: findSideInput,
        waitForSides: waitForSides,
        bindSideField: bindSideField,
    };
})(window, window.jQuery);